import { type DeviceType } from '@cx-modules/types';

export const deviceTypeConst: { [K in DeviceType]: DeviceType } = {
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
  DESKTOP: 'DESKTOP',
} as const;
